import { UhfData, UhfFooterMode, UhfHeaderMode } from "../models/uhf";
import { createAction, createAsyncAction } from "./internal/platformActionCreators";
import { UhfScope } from "./scopes";

export enum UhfActions {
  FETCH_UHF_START = "@uhf/FETCH_UHF_START",
  FETCH_UHF_COMPLETED = "@uhf/FETCH_UHF_COMPLETED",
  FETCH_UHF_ERROR = "@uhf/FETCH_UHF_ERROR",

  SET_HEADER_MODE = "@uhf/SET_HEADER_MODE",
  RESET_HEADER_MODE = "@uhf/RESET_HEADER_MODE",

  SET_FOOTER_MODE = "@uhf/SET_FOOTER_MODE",
  RESET_FOOTER_MODE = "@uhf/RESET_FOOTER_MODE",
}

export const uhfActions = {
  fetchUhf: createAsyncAction(
    UhfScope,
    UhfActions.FETCH_UHF_START,
    () => ({}),
    UhfActions.FETCH_UHF_COMPLETED,
    (data: UhfData) => ({
      data,
    }),
    UhfActions.FETCH_UHF_ERROR,
    (error: Error) => ({ error })
  ),

  setHeaderMode: createAction(UhfActions.SET_HEADER_MODE, UhfScope, (mode: UhfHeaderMode) => ({
    mode,
  })),
  resetHeaderMode: createAction(UhfActions.RESET_HEADER_MODE, UhfScope),

  setFooterMode: createAction(UhfActions.SET_FOOTER_MODE, UhfScope, (mode: UhfFooterMode) => ({
    mode,
  })),
  resetFooterMode: createAction(UhfActions.RESET_FOOTER_MODE, UhfScope),
};
